import { render, staticRenderFns } from "./headerCompose.vue?vue&type=template&id=00d3a10e&scoped=true&"
import script from "./headerCompose.vue?vue&type=script&lang=js&"
export * from "./headerCompose.vue?vue&type=script&lang=js&"
import style0 from "./headerCompose.vue?vue&type=style&index=0&id=00d3a10e&lang=scss&scoped=true&"
import style1 from "./headerCompose.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d3a10e",
  null
  
)

export default component.exports